export default "__VITE_ASSET__DHipk8Xe__"